export const authTranslationsNL = {
    getProvidersError: 'Er is een probleem opgetreden bij het ophalen van de providers.',
    getUserError: 'Er is een probleem opgetreden bij het ophalen van de gebruiker.',
    selectLoginMethod: 'Welkom terug in de Carity Support applicatie. Selecteer hieronder je login methode.',
    loginTitle: 'Welkom terug!',
    unauthenticatedTitle: 'Geen toegang',
    unauthenticatedText: 'Je gebruiker heeft momenteel geen toegang tot deze applicatie.',
    loginAgain: 'Opnieuw inloggen',
};
